import React from 'react';
import { Box } from '@mui/material';

import { MetricSnapshot } from './MetricSnapshot';
import { PanelTab } from './PanelTab';

import { MetricType, Metrics } from '../types';

type Snapshot = {
  value: MetricType;
  label: string;
  name: keyof Metrics;
};

const metricTypes: Snapshot[] = [
  {
    value: 'members',
    label: 'Memberships',
    name: 'membershipCreated',
  },
  {
    value: 'transactions',
    label: 'Loyalty Transactions',
    name: 'transactionCreated',
  },
  {
    value: 'offers',
    label: 'Offers',
    name: 'offerFulfillment',
  },
  {
    value: 'redemptions',
    label: 'Rewards',
    name: 'redemptionCreated',
  },
];

type CoreProgramSnapshotsProps = {
  metrics: Metrics;
  metricType: MetricType;
  onMetricTypeChange: (value: MetricType) => void;
};

export const CoreProgramSnapshots = ({
  onMetricTypeChange,
  metrics,
  metricType,
}: CoreProgramSnapshotsProps) => {
  const pickMetricType = (ev: React.MouseEvent<HTMLButtonElement>) => {
    onMetricTypeChange(ev.currentTarget.value as MetricType);
  };

  return (
    <Box>
      {metricTypes.map((metric) => (
        <PanelTab
          key={metric.value}
          value={metric.value}
          onClick={pickMetricType}
          active={metricType === metric.value}
        >
          <MetricSnapshot
            label={metric.label}
            metric={metrics[metric.name]}
            isSelected={metricType === metric.value}
          />
        </PanelTab>
      ))}
    </Box>
  );
};
